export default {"src":"/_next/static/media/Circle3.07f6478e.svg","height":567,"width":570,"blurWidth":0,"blurHeight":0};